// The preview carries catalogue codes (`MAKE_SKODA`, `MODEL_OCTAVIA`); the type prefix is dropped
// for reading when no label is known for the code.
export const stripVehicleSelectionCodePrefix = (code: string) => code.replace(/^[A-Z]+_/, '');
